import React from 'react';
import Modal from '../ui/Modal';
import './InvalidFileDialog.css';

interface InvalidFileDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const InvalidFileDialog: React.FC<InvalidFileDialogProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="invalid-file-dialog-modal"
      showCloseButton={true}
      closeOnOverlayClick={true}
      title=' '
    >
      <div className="invalid-file-dialog">
        <div className="invalid-file-icon-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
            <g clipPath="url(#clip0_11_7744)">
              <path d="M60 0C93.1367 0.000239051 120 26.8633 120 60C120 93.1367 93.1367 120 60 120C26.8633 120 0.00023902 93.1367 0 60C0.000239919 26.8633 26.8633 0.00023995 60 0ZM29.627 98.5684C37.9833 105.158 48.5322 109.091 60 109.091C87.1118 109.091 109.091 87.1118 109.091 60C109.091 48.5322 105.158 37.9833 98.5684 29.627L29.627 98.5684ZM60 10.9082C32.8882 10.9084 10.9084 32.8882 10.9082 60C10.9083 71.4674 14.8421 82.016 21.4316 90.3721L90.3721 21.4316C82.016 14.8421 71.4674 10.9083 60 10.9082Z" fill="url(#paint0_linear_11_7744)" />
            </g>
            <defs>
              <linearGradient id="paint0_linear_11_7744" x1="-1.36904e-06" y1="60" x2="120" y2="60" gradientUnits="userSpaceOnUse">
                <stop stopColor="#D94B4B" />
                <stop offset="1" stopColor="#ED7A24" />
              </linearGradient>
              <clipPath id="clip0_11_7744">
                <rect width="120" height="120" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <h2 className="invalid-file-title">File format not supported!</h2>

        <button
          className="invalid-file-button"
          onClick={onClose}
        >
          Try again
        </button>
        
        <p className="invalid-file-subtitle">
          This file type isn't supported. Supported formats are: PDF, PPT, PPTX, DOC, DOCX, CSV, XLS, XLSX, JSON.
        </p>
      </div>
    </Modal>
  );
};

export default InvalidFileDialog;